import type { Moment } from 'moment';
import type { CoreTypes } from '../core';
import { Constants } from './constants';

export default (day: number | CoreTypes.day, time: string): Moment => {
  if (day == null) throw new Error('Day is null or undefined');

  const _day = typeof day == 'number' ? day : day.day;
  const [hours, minutes] = time.split(':').map(x => parseInt(x));

  const date = Constants.FIRST_DAY.clone()
    .add(_day, 'day')
    .set('hour', hours)
    .set('minute', minutes);

  if (!date.isValid()) throw new Error(`Day ${ _day } and time ${ time } is not a valid date`);

  return date;
};